// Sort layers for better display on the maap

export const sortLayers = (layers) => {
  if(!Array.isArray(layers)) return [];
  return layers.sort((a, b) => { return a.ordinamento - b.ordinamento });
}

export default sortLayers